'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propEnhancers = exports.propValidators = exports.propAliases = exports.propTypes = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _getCss = require('../get-css');

var _getCss2 = _interopRequireDefault(_getCss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = exports.propTypes = {
  opacity: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
};

var propAliases = exports.propAliases = {};

var propValidators = exports.propValidators = {};

var _opacity = {
  className: 'opct',
  cssName: 'opacity',
  jsName: 'opacity',
  defaultUnit: ''
};

var propEnhancers = exports.propEnhancers = {
  opacity: function opacity(value) {
    return (0, _getCss2.default)(_opacity, value);
  }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9lbmhhbmNlcnMvb3BhY2l0eS5qcyJdLCJuYW1lcyI6WyJwcm9wVHlwZXMiLCJvcGFjaXR5IiwiUHJvcFR5cGVzIiwib25lT2ZUeXBlIiwic3RyaW5nIiwibnVtYmVyIiwicHJvcEFsaWFzZXMiLCJwcm9wVmFsaWRhdG9ycyIsImNsYXNzTmFtZSIsImNzc05hbWUiLCJqc05hbWUiLCJkZWZhdWx0VW5pdCIsInByb3BFbmhhbmNlcnMiLCJ2YWx1ZSJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOzs7O0FBQ0E7Ozs7OztBQUVPLElBQU1BLGdDQUFZO0FBQ3ZCQyxXQUFTQyxvQkFBVUMsU0FBVixDQUFvQixDQUFDRCxvQkFBVUUsTUFBWCxFQUFtQkYsb0JBQVVHLE1BQTdCLENBQXBCO0FBRGMsQ0FBbEI7O0FBSUEsSUFBTUMsb0NBQWMsRUFBcEI7O0FBRUEsSUFBTUMsMENBQWlCLEVBQXZCOztBQUVQLElBQU1OLFdBQVU7QUFDZE8sYUFBVyxNQURHO0FBRWRDLFdBQVMsU0FGSztBQUdkQyxVQUFRLFNBSE07QUFJZEMsZUFBYTtBQUpDLENBQWhCOztBQU9PLElBQU1DLHdDQUFnQjtBQUMzQlgsV0FBUztBQUFBLFdBQVMsc0JBQU9BLFFBQVAsRUFBZ0JZLEtBQWhCLENBQVQ7QUFBQTtBQURrQixDQUF0QiIsImZpbGUiOiJvcGFjaXR5LmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFByb3BUeXBlcyBmcm9tICdwcm9wLXR5cGVzJ1xuaW1wb3J0IGdldENzcyBmcm9tICcuLi9nZXQtY3NzJ1xuXG5leHBvcnQgY29uc3QgcHJvcFR5cGVzID0ge1xuICBvcGFjaXR5OiBQcm9wVHlwZXMub25lT2ZUeXBlKFtQcm9wVHlwZXMuc3RyaW5nLCBQcm9wVHlwZXMubnVtYmVyXSlcbn1cblxuZXhwb3J0IGNvbnN0IHByb3BBbGlhc2VzID0ge31cblxuZXhwb3J0IGNvbnN0IHByb3BWYWxpZGF0b3JzID0ge31cblxuY29uc3Qgb3BhY2l0eSA9IHtcbiAgY2xhc3NOYW1lOiAnb3BjdCcsXG4gIGNzc05hbWU6ICdvcGFjaXR5JyxcbiAganNOYW1lOiAnb3BhY2l0eScsXG4gIGRlZmF1bHRVbml0OiAnJ1xufVxuXG5leHBvcnQgY29uc3QgcHJvcEVuaGFuY2VycyA9IHtcbiAgb3BhY2l0eTogdmFsdWUgPT4gZ2V0Q3NzKG9wYWNpdHksIHZhbHVlKVxufVxuIl19